import { gsap } from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import img1 from "../../assets/images/fabric-1.jpg";
import img2 from "../../assets/images/fabric-2.jpg";
import img3 from "../../assets/images/fabric-3.jpg";
import img4 from "../../assets/images/fabric-4.jpg";
import img5 from "../../assets/images/fabric-5.jpg";
import ParagraphReveal from "../ParagraphReveal/ParagraphReveal";
import { titleInEase } from "../../utils/Eases";
import s from "./ColorsAndFabric.module.scss";

const ColorsAndFabric = () => {
  const titleRef = useRef();
  const { t } = useTranslation();

  useEffect(() => {
    const fabrics = document.querySelectorAll("[data-fabric]");
    let text = t("colorsAndFabrics.title");
    const words = text.split(" ");
    text = text.replace(/\s/g, "");

    const classes = [s.colors, s.and, s.fabrics];

    words.forEach((word, wordIndex) => {
      const div = document.createElement("div");
      const letters = word.split("");

      div.classList.add(classes[wordIndex]);

      letters.forEach((letter, letterIndex) => {
        const span = document.createElement("span");
        span.innerHTML = letter;

        span.setAttribute("data-mask", "");

        if (letter === "o" && letterIndex === 3) {
          span.classList.add("yellow");
          const emptySpan = document.createElement("span");
          div.appendChild(emptySpan);

          span.removeAttribute("data-mask");
          span.setAttribute("data-rotation", "");
        }

        if (letter === "b") {
          const emptySpan = document.createElement("span");
          div.appendChild(emptySpan);

          span.classList.add("salmon");
          span.removeAttribute("data-mask");
          span.setAttribute("data-rotation", "");
        }

        div.appendChild(span);
      });

      titleRef.current.appendChild(div);
    });

    const letters = document.querySelectorAll("#colors h1 [data-mask]");
    const lettersToRotate = document.querySelectorAll(
      "#colors h1 [data-rotation]"
    );

    gsap.fromTo(
      letters,
      {
        y: "160%",
      },
      {
        stagger: 0.1,
        duration: 1.2,
        ease: titleInEase,

        y: "20%",
        scrollTrigger: {
          trigger: titleRef.current,
          start: "top 75%",
          end: `+=${window.innerHeight * 0.4}`,
          // scrub: true,
        },
      }
    );
    gsap.fromTo(
      lettersToRotate,
      {
        transformOrigin: "50% 50%",
        rotationX: -270,
        // z: -100,
      },
      {
        // z: 100,
        duration: 1.5,
        stagger: 0.4,
        rotationX: 0,
        scrollTrigger: {
          trigger: titleRef.current,
          start: "top 75%",
          end: `+=${window.innerHeight * 0.4}`,
          // scrub: true,
          // markers: {},
        },
      }
    );

    const trigger = ScrollTrigger.create({
      trigger: document.getElementById("colors"),
      start: "top top",
      end: `+=${window.innerHeight * 2}`,
      scrub: true,
      // markers: true,
      onUpdate: ({ progress }) => {
        // console.log();
        gsap.set(titleRef.current, { y: window.innerHeight * progress + "px" });
      },
    });

    // gsap.to(titleRef.current, {
    //   // y: `${window.innerHeight}px`,
    //   scrollTrigger: {
    //     trigger: document.getElementById("colors"),
    //     start: "top top",
    //     end: `+=${window.innerHeight * 2}`,
    //     scrub: 0.1,
    //     anticipatePin: 2,
    //     onUpdate: (self) => {
    //       gsap.set(titleRef.current, { y: 100 * self.progress + "%" });
    //     },
    //     // pin: true,

    //     // markers: {},
    //   },
    // });

    fabrics.forEach((fabric, i) => {
      gsap.fromTo(
        fabric,
        {
          "will-change": "opacity, transform",
          transformOrigin: "50% 50%",
          opacity: 0,
          rotationX: 45,
          z: -100,
        },
        {
          z: 0,
          opacity: 1,
          rotationX: 0,
          scrollTrigger: {
            trigger: fabric,
            start: "top 75%",
            end: `+=300px`,
            scrub: true,
            // markers: {},
          },
        }
      );
    });

    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 1000);
  }, []);

  return (
    <div id="colors" className={s.colorsAndFabric}>
      <div className={s.fabricWrapper}>
        <div className={s.fabric1} data-fabric>
          <img src={img1} alt="" />
        </div>
      </div>
      <ParagraphReveal className={s.intro}>
        {t("colorsAndFabrics.description")}
      </ParagraphReveal>

      <h1 ref={titleRef} data-lenis-prevent></h1>

      <div className={s.fabricWrapper}>
        <div className={s.fabric2} data-fabric>
          <img src={img2} alt="" />
        </div>

        <div className={s.fabric3} data-fabric>
          <img src={img3} alt="" />
        </div>

        <div className={s.fabric4} data-fabric>
          <img src={img4} alt="" />
        </div>

        <div className={s.fabric5} data-fabric>
          <img src={img5} alt="" />
        </div>

        <ParagraphReveal className={s.closing}>
          {t("colorsAndFabrics.closing_paragraph")}
        </ParagraphReveal>
      </div>
    </div>
  );
};

export default ColorsAndFabric;
